export const storagePrefix = 'dome-auctions-nt-';
